import React from 'react';
import { areEqual } from 'react-window';
import { formatTime } from 'pano-utils';
import { type LibItemSysAudio, MediaType } from '@types';
import type { ItemListRowProps } from '@components/ItemList';
import { $isVip } from '@stores/memberStores';
import { TipWrapper } from '@components/TipWrapper';
import onItemClick from '../actions/onItemClick';
import LibItemContainer from '../layouts/LibItemContainer';
import ItemCheckBox from '../components/ItemCheckBox';
import LibItemName from '../layouts/LibItemName';
import AudioBtn from '../components/AudioBtn';
import showVipModal from './showVipModal';
import ImgVip from './img-vip.png';
import IconInfo from './IconInfo';

interface Props extends ItemListRowProps {
  data: {
    items: LibItemSysAudio[];
  };
}

function RowSysAudio({ index, data, style }: Props) {
  const { items } = data;
  const item = items[index];

  const handleClick = () => {
    if (!item.free && !$isVip.getState()) {
      showVipModal();
    } else {
      onItemClick(item.id);
    }
  };

  return (
    <LibItemContainer style={style} onClick={handleClick}>
      <ItemCheckBox id={item.id} />
      <AudioBtn id={item.id} mediaType={MediaType.system} src={item.url} />
      <LibItemName>{item.name}</LibItemName>
      {!!item.copyright && (
        <TipWrapper
          text={`音乐来源：${item.copyright}`}
          className="mx-5 flex-shrink-0"
          size="sm"
        >
          <IconInfo scheme="light" />
        </TipWrapper>
      )}
      {!item.free && (
        <img src={ImgVip} alt="" className="mx-5 h-16 w-16 flex-shrink-0" />
      )}
      <div className="ml-auto flex-shrink-0 text-black-gray">
        {formatTime(item.duration)}
      </div>
    </LibItemContainer>
  );
}

export default React.memo(RowSysAudio, areEqual);
